<template>
  <div class="toolbar" :class="{ 'only-one': !props.showSelectBoard }">
    <div v-if="props.showSelectBoard !== false" class="select-board-wrapper">
      <button class="select-board" @click="handleSelectBoard">
        <span
          >{{ t("post.create.selectBoard") }} -
          {{
            capitalizeFirstLetter(
              t(`home.tags.${threadStore.selectedBoardName}`)
            )
          }}</span
        >
      </button>
    </div>
    <button
      v-if="props.showSubmit"
      class="toolbar-submit-btn"
      :disabled="props.disabled"
      :class="{ disabled: props.disabled }"
      @click="emit('submit')"
    >
      {{ props.submitText || t("post.create.submit") }}
    </button>
  </div>
</template>

<script setup lang="ts">
import { onMounted, defineProps, computed } from "vue";
import { useI18n } from "vue-i18n";
import { useRouter, useRoute } from "vue-router";
import { useThreadStore } from "@/stores";
import { useForumStore } from "@/stores";
import { clickButton, pageType } from "@/utils/point";
import { capitalizeFirstLetter } from "@/utils";
const { t } = useI18n();
const router = useRouter();
const route = useRoute();
const threadStore = useThreadStore();
const forumStore = useForumStore();

const props = defineProps<{
  showSelectBoard?: boolean;
  showSubmit?: boolean;
  submitText?: string;
  disabled?: boolean;
}>();

const emit = defineEmits<{
  (e: "submit"): void;
}>();

onMounted(() => {
  // 如果当前板块不存在，则设置为默认板块
  if (forumStore.forumSections.length === 0) {
    forumStore.getForumInfo();
  }
});

const handleSelectBoard = () => {
  clickButton({
    eventType: pageType.POST,
    eventReason: "点击选择版区",
  });
  router.push({
    path: "/select-board",
    query: {
      ...route.query,
    },
  });
};
</script>

<style scoped>
.toolbar {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100vw;
  background: #fff;
  border-top: 1px solid #f0f0f0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 16px;
  z-index: 10;
  &.only-one {
    justify-content: flex-end;
  }
}

.toolbar-left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.toolbar-icon {
  width: 28px;
  height: 28px;
  cursor: pointer;
}

.select-board-wrapper {
  display: flex;
  justify-content: flex-start;
}

.select-board {
  background: #fff;
  border: 1px solid #ffb400;
  border-radius: 16px;
  padding: 6px 14px;
  font-size: 12px;
  color: #e9a400;
  cursor: pointer;
}

.hidden-input {
  display: none;
}

.toolbar-submit-btn {
  background: #ffb400;
  color: #fff;
  border: none;
  border-radius: 14px;
  padding: 6px 12px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
}

.toolbar-submit-btn.disabled,
.toolbar-submit-btn:disabled {
  background: #d3d3d3;
  color: #fff;
  cursor: not-allowed;
}
</style>
